// API functions for note operations

enum NoteType {
  Action = "action",
  Insight = "insight",
}

enum NoteFormat {
  Html = "html",
  Text = "text",
  Markdown = "md",
}

export interface NoteSearchCriteria {
  processId?: string;
  type?: NoteType;
  content?: string;
  assignedTo?: string;
  createdBy?: string;
  updatedBy?: string;
  format?: NoteFormat;
}

export function getNoteType(value: string): NoteType | undefined {
  const foundArray = Object.entries(NoteType)
    .filter(([k, v]) => v == value)
    .map(([k, v]) => k);
  if (foundArray.length === 0) {
    return undefined;
  }
  return foundArray[0] as NoteType;
}
export function getNoteFormat(value: string): NoteFormat | undefined {
  const foundArray = Object.entries(NoteFormat)
    .filter(([k, v]) => v == value)
    .map(([k, v]) => k);
  if (foundArray.length === 0) {
    return undefined;
  }
  return foundArray[0] as NoteFormat;
}

export function getNoteSearchQuery(criteria: NoteSearchCriteria): string {
  const q = new URLSearchParams();
  const fields: (keyof NoteSearchCriteria)[] = [
    "processId",
    "type",
    "content",
    "assignedTo",
    "createdBy",
    "updatedBy",
    "format",
  ];
  fields.forEach((k) => {
    if (criteria[k]) {
      q.set(k, criteria[k] ?? "");
    }
  });
  return q.toString();
}

export interface TakeAway {
  id?: string;
  type: NoteType;
  content: string;
  assignedTo: string;
  createdBy: string;
  activityId?: string;
  createdAt?: string;
  updatedAt?: string;
}

interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
}
